import { render, staticRenderFns } from "./AcceptCookiesPopup.vue?vue&type=template&id=ade037ee&scoped=true"
import script from "./AcceptCookiesPopup.vue?vue&type=script&lang=js"
export * from "./AcceptCookiesPopup.vue?vue&type=script&lang=js"
import style0 from "./AcceptCookiesPopup.vue?vue&type=style&index=0&id=ade037ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade037ee",
  null
  
)

export default component.exports